// extracted by mini-css-extract-plugin
module.exports = {"footerLogoContainer":"style_footerLogoContainer__1jGG1","logo":"style_logo__2y5Dh"};